import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

import { NotificationSettingsMfe } from '@/features/microfrontends/NotificationSettingsMfe';
import AnalyticsEvents from '@/analytics/AnalyticsEvents';

export enum SettingsDialogContentType {
    notifications = 'notifications',
}

export const settingsDialogTabSearchParameter = 'settingsTab';

const SettingsDialog = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const settingsTab = new URLSearchParams(location.search).get(settingsDialogTabSearchParameter) as SettingsDialogContentType | null;
    if (settingsTab === SettingsDialogContentType.notifications) AnalyticsEvents.openNotificationSettings();

    const onClose = () => {
        const currentSearchParams = new URLSearchParams(location.search);
        currentSearchParams.delete(settingsDialogTabSearchParameter);
        navigate({
            search: currentSearchParams.toString(),
        });
    };

    return (
        <Dialog
            show={!!settingsTab}
            title={<FormattedMessage id="intl-msg:fleetstatus.notification_settings" />}
            bsSize="md"
            body={<NotificationSettingsMfe />}
            showCloseButton
            onClose={onClose}
        />
    );
};

export default SettingsDialog;
